import React, { useState, useEffect } from "react";
import { Form, Button, Checkbox } from "antd";
import axios from "axios";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import "./login.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import styled from "styled-components";
import {
	StyledInput,
	StyledPasswordInput
} from "./customComponents/styled_input";
import { set_user_ID } from "../store/images";

const BasicLogin = () => {
	const StyledCheckBox = styled(Checkbox)`
   border-radius:0px;
   font-family: 'Montserrat', sans-serif;
  &.ant-checkbox-wrapper {
  
    .ant-checkbox-inner {
    
      border-color: lightgrey !important; /* Default border color */
    }

    &:hover .ant-checkbox-inner {
      border-color: #f04ca4 !important; /* Border color on hover */
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #f04ca4 !important; /* Background color when checked */
      border-color: #f04ca4 !important; /* Border color when checked */
    }

    &:hover .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #FF0083 !important; /* Background color when checked and hovered */
      border-color: #FF0083 !important; /* Border color when checked and hovered */
    }

    .ant-checkbox-inner:active {
      border-color: #FF0083 !important; /* Border color when active (clicked) */
    }

    .ant-checkbox-checked .ant-checkbox-inner:active {
      background-color: #FF0083 !important; /* Background color when checked and active */
      border-color: #FF0083 !important; /* Border color when checked and active */
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: white !important; /* Checkmark color */
    }

    &:hover .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: white !important; /* Checkmark color on hover */
    }
  }

`;

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [username, setUsername] = useState(null);
	const [password, setPassword] = useState(null);
	const [authenticationFailed, setAuthenticationFailed] = useState(false);
	const [usernameHelperMessage, setUsernameHelperMessage] = useState(null);
	const [passwordHelperMessage, setPasswordHelperMessage] = useState(null);
	const [rememberMe, setRememberMe] = useState(false);
	const surveyorIcon = `${process.env.PUBLIC_URL}/custom-icons/surveyorIcon.png`;
	const illustration = `${process.env.PUBLIC_URL}/custom-icons/login_img.png`;

	const handleInputChange = (type, e) => {
		let value = e.target.value;

		if (type === "username") {
			if (!value && value.length < 0) {
				setUsernameHelperMessage("Username cannot be empty");
			} else {
				setUsernameHelperMessage(null);
				setUsername(value);
			}
		}

		if (type === "password") {
			if (!value && value.length < 0) {
				setPasswordHelperMessage("Password cannot be empty");
			} else {
				setPasswordHelperMessage(null);
				setPassword(value);
			}
		}
	};

	const [form] = Form.useForm();

	// const onFinish = async values => {
	//   if (!values.Username) {
	//     setUsernameHelperMessage('Username cannot be empty');
	//   } else {
	//     setUsernameHelperMessage(null);
	//   }

	//   if (!values.Password) {
	//     setPasswordHelperMessage('Password cannot be empty');
	//   } else {
	//     setPasswordHelperMessage(null);
	//   }

	//   setLoading(true);
	//   axios.post('/auth/authenticate', {
	//     username: values.Username,
	//     password: values.Password
	//   })
	//     .then(r => {
	//       localStorage.setItem('insuranceUser', JSON.stringify(r.data));
	//       setLoading(false);
	//       console.log(r.data);

	//       dispatch(appActions.addUser(r.data));
	//       navigate('/app/home');
	//     })
	//     .catch(err => {
	//       console.log('error', err);
	//       setLoading(false);
	//       setAuthenticationFailed(true);
	//     });
	// };

	const onFinish = async values => {
		if (!values.Username) {
			setUsernameHelperMessage("Username cannot be empty");
		} else {
			setUsernameHelperMessage(null);
		}

		if (!values.Password) {
			setPasswordHelperMessage("Password cannot be empty");
		} else {
			setPasswordHelperMessage(null);
		}

		setLoading(true);

		try {
			const response = await axios.post('/auth/login', {
				email: values.Username,
				password: values.Password
			});
			localStorage.setItem("token", response.data.token);
			const userId = response.data.userID;
			console.log("152",response.data);
			dispatch(set_user_ID(userId));
			console.log("dispatched");


			localStorage.setItem('insuranceUser', JSON.stringify({
				username: values.Username,
				password: values.Password,
				userId: userId
			}));
			if (values.rememberMe) {
				document.cookie = `username=${values.Username}; path=/`;
				document.cookie = `password=${values.Password}; path=/`;
			} else {
				document.cookie = 'username=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
				document.cookie = 'password=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
			}
			if (response.data.islogin) {
				setLoading(false);
			} else {
				setAuthenticationFailed(true);
			}
			//   dispatch(appActions.addUser(response.data));
			navigate(`/home`, { state: { userId } });
		} catch (err) {
			console.log("error", err);
			setLoading(false);
			setAuthenticationFailed(true);
		}
	};
	useEffect(
		() => {
			const cookies = document.cookie.split("; ").reduce((prev, curr) => {
				const [key, value] = curr.split("=");
				prev[key] = value;
				return prev;
			}, {});

			if (cookies.username) {
				setUsername(cookies.username);
				form.setFieldsValue({ Username: cookies.username });
			}

			if (cookies.password) {
				setPassword(cookies.password);
				form.setFieldsValue({ Password: cookies.password });
			}
		},
		[form]
	);

	//  logged in check
	 useEffect(() => {
    const user = localStorage.getItem('insuranceUser');
    if (user) {
      navigate('/home', { replace: true });
    }
  }, [navigate]);

  //  back btn block
  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    
    const handlePopState = () => {
      window.history.pushState(null, null, window.location.href);
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

	return (
		<div className="responsive-login-container">
			<div className="login-illustration">
				{/* <img src={illustration} alt="Illustration" /> */}
				<LazyLoadImage alt="Illustration" effect="opacity" src={illustration} />
				{/* <LazyLoadImage alt="Illustration" effect="opacity" src="https://res.cloudinary.com/djhvnzuvm/image/upload/v1723625083/insurance-inspection/b8homiwbtighuwyvaq6g.png" /> */}
			</div>
			<div className="login-form-container">
				{/* <img src={surveyorIcon} alt="Surveyor's AI" className="surveyor-icon" /> */}
				<LazyLoadImage
					src={surveyorIcon}
					alt="Surveyor's AI"
					className="surveyor-icon"
					effect="opacity"
				/>

				<h4 className="signin-text">Sign in to your account</h4>
				<Form
					className="form-data"
					form={form}
					onFinish={onFinish}
					layout="vertical"
				>
					<div className="login-basic">
						<Form.Item
							name="Username"
							help={
								<span style={{ color: "red" }}>
									{usernameHelperMessage}
								</span>
							}
						>
							<div className="email-container">
								<StyledInput
									className="login-email"
									value={username}
									placeholder="Email Address"
									onChange={e => handleInputChange("username", e)}
								/>
							</div>
						</Form.Item>

						<Form.Item
							name="Password"
							help={
								<span style={{ color: "red" }}>
									{passwordHelperMessage}
								</span>
							}
						>
							<div className="password-container">
								<StyledPasswordInput
									className="login-pass"
									value={password}
									placeholder="Password"
									onChange={e => handleInputChange("password", e)}
								/>
							</div>
						</Form.Item>

						<Form.Item
							name="rememberMe"
							valuePropName="checked"
							className="remember-me"
						>
							{/* <Checkbox>Remember Me</Checkbox> */}
							<StyledCheckBox>Remember me</StyledCheckBox>
						</Form.Item>

						<Form.Item className="login-btn-container">
							<Button className="login-btn" type="primary" htmlType="submit">
								Login {loading && <Loading3QuartersOutlined spin />}
							</Button>
							<div className="helper-text">
								{authenticationFailed &&
									<span>Invalid credentials, please try again...</span>}
							</div>
							<a href="/forgot-password" className="forgot-password">
								Forgot Password
							</a>
							{/* <Link to="/forgot-password" className="forgot-password">Forgot Password</Link> */}
						</Form.Item>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default BasicLogin;
